import { action, payload } from 'ts-action'
import {
  IUpshifterExperience,
  IUpshifterExperienceEnums,
} from 'models/UpshifterExperience'
import { IError, IPayload } from 'models/Global'

export const UpshifterExperiencesFetching = action(
  'UpshifterExperiencesFetching',
  payload<boolean>(),
)

export const GetUpshifterExperiences = action(
  'GetUpshifterExperiences',
  payload<IPayload<IUpshifterExperience[]>>(),
)

export const GetUpshifterExperiencesErrors = action(
  'GetUpshifterExperiencesErrors',
  payload<IError>(),
)

export const AddUpshifterExperience = action(
  'AddUpshifterExperience',
  payload<IPayload<IUpshifterExperience>>(),
)

export const UpdateUpshifterExperience = action(
  'UpdateUpshifterExperience',
  payload<IPayload<IUpshifterExperience>>(),
)

export const DeleteUpshifterExperience = action(
  'DeleteUpshifterExperience',
  payload<number>(),
)

export const GetIsEditExperienceModal = action(
  'GetIsEditExperienceModal',
  payload<boolean>(),
)

export const GetUpshifterExperienceEnums = action(
  'GetUpshifterExperienceEnums',
  payload<IUpshifterExperienceEnums>(),
)

export const ClearUpshifterExperienceReducer = action(
  'ClearUpshifterExperienceReducer',
)
